import { makeActions } from '@redux/crudCreator/actions';
import { convertResponseData } from '@redux/crudCreator/dataProvider';
import { apiWrapper } from '@redux/crudCreator/reduxUtils';
import { CreatePayloadType } from '@redux/crudCreator/types';
import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  confirmOrderApi,
  createShippingNoApi,
  editInvoiceInformationApi,
  editPickupInformationApi,
  markAsCompleteApi,
} from 'api/orders';

export const MODEL_NAME = 'ordersTabTryBuy';
export const ordersTabTryBuyActions = makeActions(MODEL_NAME, 'id', 'orders');

export const getAllOrdersTabTryBuy = ordersTabTryBuyActions.getAll;
export const editOrdersTabTryBuy = ordersTabTryBuyActions.edit;
export const createOrdersTabTryBuy = ordersTabTryBuyActions.create;
export const getByIdOrdersTabTryBuy = ordersTabTryBuyActions.getDataById;

export const markAsComplete = createAsyncThunk(
  'ordersTabTryBuy/markAsComplete',
  async (payload: CreatePayloadType, thunkAPI) => {
    const { data } = payload;
    try {
      const response = await apiWrapper(
        { isShowSuccessNoti: true },
        markAsCompleteApi,
        data,
      );
      if (response) {
        return { success: true, data: response };
      }
      return thunkAPI.rejectWithValue({ error: true, response });
    } catch (error) {
      return thunkAPI.rejectWithValue({ data: error, error: true });
    }
  },
);

export const editPickupInformation = createAsyncThunk(
  'ordersTabTryBuy/editPickupInformation',
  async (payload: any, thunkAPI) => {
    const { data } = payload;
    try {
      const response = await apiWrapper(
        { isShowSuccessNoti: true },
        editPickupInformationApi,
        data,
      );
      if (response) {
        return response;
      }
      return thunkAPI.rejectWithValue({ success: false, response });
    } catch (error) {
      return thunkAPI.rejectWithValue({ data: error, error: true });
    }
  },
);

export const editInvoiceInformation = createAsyncThunk(
  'ordersTabTryBuy/editInvoiceInformation',
  async (payload: any, thunkAPI) => {
    const { data, options } = payload;
    try {
      const response = await apiWrapper(
        { isShowSuccessNoti: true },
        editInvoiceInformationApi,
        data,
      );
      const result = convertResponseData('EDIT', response, {
        primaryKey: 'id',
      });
      if (result) {
        return { data: { ...data, ...result }, options };
      }
      return thunkAPI.rejectWithValue({
        error: true,
        data: { ...data, ...response },
      });
      // return thunkAPI.rejectWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const confirmOrder = createAsyncThunk(
  'ordersTabTryBuy/confirmOrder',
  async (payload: CreatePayloadType, thunkAPI) => {
    const { data, options } = payload;
    try {
      const response = await apiWrapper(options, confirmOrderApi, data);
      if (response) {
        return response;
      }
      return thunkAPI.rejectWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const createShippingNo = createAsyncThunk(
  'ordersTabTryBuy/createShippingNo',
  async (payload: CreatePayloadType, thunkAPI) => {
    const { data } = payload;
    try {
      const response = await apiWrapper(
        { isShowSuccessNoti: true },
        createShippingNoApi,
        data,
      );
      if (response) {
        return { success: true, data: response };
      }
      return thunkAPI.rejectWithValue({ error: true, response });
    } catch (error) {
      return thunkAPI.rejectWithValue({ data: error, error: true });
    }
  },
);
